import { render } from "./NodeRedEditor.vue?vue&type=template&id=b6a854f6&ts=true"
import script from "./NodeRedEditor.vue?vue&type=script&lang=ts"
export * from "./NodeRedEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__